import { gql } from '@apollo/client';
import { query } from '../../../../Services/Gateway/Apollo';
import { getCompositeSubmissionId } from '../../../../Helpers/originId';

export const GET_LEAD_STATUS = gql`
  query GetLeadStatus($submissionId: String!) {
    getLeadStatus(submissionId: $submissionId) {
      submissionId
      status
      outcome
      messageKey
    }
  }
`;

const getLeadStatusQuery = async ({ variables, token }) => {
  const context = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await query({
    query: GET_LEAD_STATUS,
    variables: {
      ...variables,
      submissionId: getCompositeSubmissionId(variables.submissionId),
    },
    fetchPolicy: 'no-cache',
    context,
  });

  return response.data.getLeadStatus;
};

export default getLeadStatusQuery;
